import { Pipe, PipeTransform } from '@angular/core';
import type { CashSession } from '../../../../data/src/lib/entities/treasury.model';
import { normalizeId } from '@shared/utils';

const SYSTEM_PERSON_ID = '10000000-0000-0000-0000-000000000000';
const SYSTEM_PERSON_DISPLAY_NAME = 'Sistema';
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const firstNonEmptyTrimmed = (
  ...values: (string | null | undefined)[]
): string | undefined => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    const trimmed = String(value).trim();
    if (trimmed) return trimmed;
  }
  return undefined;
};

@Pipe({ name: 'cashSessionOpenedByLabel', standalone: true, pure: true })
export class CashSessionOpenedByLabelPipe implements PipeTransform {
  transform(
    session: CashSession,
    personNameById?: ReadonlyMap<string, string>,
  ): string {
    const fromSession = firstNonEmptyTrimmed(
      session.OpenedByName,
      session.OpenedByFullName,
    );
    if (fromSession) {
      return fromSession;
    }

    const raw = (normalizeId(session.OpenedBy) ?? '').trim();
    if (!raw) return '—';
    if (raw.toLowerCase() === SYSTEM_PERSON_ID) {
      return SYSTEM_PERSON_DISPLAY_NAME;
    }
    const named = personNameById?.get(raw);
    if (named) return named;
    if (UUID_RE.test(raw)) return '—';
    return raw;
  }
}
